<template>
  <div class="home">123</div>
</template>

<script>
export default {
  name: "HomeView",
};
</script>
